"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstance = exports.VueAuth0 = void 0;
const auth0_spa_js_1 = __importDefault(require("@auth0/auth0-spa-js"));
const vue_1 = __importDefault(require("vue"));
const graphql_types_1 = require("@freelancerepublik/graphql-types");
const Freelance_core_1 = require("@freelancerepublik/models-core/Freelance.core");
const Role_core_1 = require("@freelancerepublik/models-core/Role.core");
const utils_core_1 = require("@freelancerepublik/models-core/utils.core");
const auth_generated_1 = require("./auth.generated");
exports.VueAuth0 = vue_1.default.extend({
    props: {
        apolloClient: {
            type: Object,
        },
        auth0ClientOptions: {
            type: Object,
        },
        defaultRedirectUri: {
            type: String,
        },
        logoutReturnTo: {
            type: String,
        },
        onRedirectCallback: {
            type: Function,
        },
    },
    data() {
        return {
            loading: true,
            isAuthenticated: false,
            auth0Client: null,
            auth0User: null,
            loggedUser: null,
            error: null,
        };
    },
    computed: {
        isFreelance() {
            // TODO Adapt function models to Codegen
            // @ts-ignore
            return (0, Role_core_1.hasRoles)(this.loggedUser, [graphql_types_1.Role.Freelance]);
        },
        isClient() {
            // TODO Adapt function models to Codegen
            // @ts-ignore
            return (0, Role_core_1.hasRoles)(this.loggedUser, [graphql_types_1.Role.Client]);
        },
    },
    methods: {
        /** Authenticates the user using the redirect method */
        loginWithRedirect(o) {
            return this.auth0Client?.loginWithRedirect({
                redirect_uri: this.defaultRedirectUri,
                ...o,
            });
        },
        /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
        getTokenSilently(o) {
            return this.auth0Client?.getTokenSilently(o);
        },
        /** Logs the user out and removes their session on the authorization server */
        async logout(o = {}) {
            await this.apolloClient.clearStore();
            return this.auth0Client?.logout({
                returnTo: this.logoutReturnTo,
                ...o,
            });
        },
        setLoggedUser(user) {
            this.loggedUser = user;
            if (this.loggedUser) {
                this.$sentry.configureScope(scope => {
                    scope.setUser({
                        email: this.loggedUser?.email,
                        // TODO in fact, _id is not nullable
                        // @ts-ignore
                        id: this.loggedUser?._id,
                    });
                });
                const userProperties = {
                    createdAt: this.loggedUser.createdAt,
                    email: this.loggedUser.email,
                    fullname: this.loggedUser.fullname,
                    firstname: this.loggedUser.firstname,
                    lastname: this.loggedUser.lastname,
                    roles: this.loggedUser.roles,
                };
                let properties = userProperties;
                if (this.isFreelance) {
                    properties = {
                        ...userProperties,
                        expectedContract: (0, utils_core_1.getLabelByValue)(Freelance_core_1.EXPECTED_CONTRACT_OPTIONS, this.loggedUser.freelance.expectedContract),
                        source: this.loggedUser.freelance.source,
                        jobCategories: this.loggedUser.freelance.jobCategories,
                        // We don't query user.client.status in loggedUser and it's not that useful anyway
                        status: (0, utils_core_1.getLabelByValue)(Freelance_core_1.FREELANCE_STATUS_OPTIONS, this.loggedUser.freelance.status),
                    };
                }
                this.$rudderanalytics.identify(this.loggedUser._id, properties);
                this.$rudderanalytics.trackUserLogin();
            }
        },
        async refreshLoggedUser() {
            await this.apolloClient.refetchQueries({
                include: ['loggedUser'],
            });
            // this.setLoggedUser(this.$auth.loggedUser);
        },
    },
    /** Use this lifecycle method to instantiate the SDK client */
    async created() {
        const options = {
            redirect_uri: window.location.origin,
            ...this.auth0ClientOptions,
        };
        // Create a new instance of the SDK client using members of the given options object
        this.auth0Client = await (0, auth0_spa_js_1.default)({
            ...options,
            useRefreshTokens: true,
            cacheLocation: 'localstorage',
        });
        if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
            // handle the redirect and retrieve tokens
            const { appState } = await this.auth0Client.handleRedirectCallback();
            this.error = null;
            if (this.onRedirectCallback) {
                this.onRedirectCallback(appState);
            }
        }
        // Initialize our internal authentication state
        this.isAuthenticated = await this.auth0Client.isAuthenticated();
        this.auth0User = await this.auth0Client.getUser();
        if (this.isAuthenticated) {
            try {
                const data = this.apolloClient.readQuery({ query: auth_generated_1.LoggedUserDocument });
                if (data.loggedUser) {
                    this.setLoggedUser(data.loggedUser);
                    this.loading = false;
                }
            }
            catch (e) {
                if (process.env.NODE_ENV === 'development') {
                    console.info('[DEBUG] No logged user in cache !');
                }
            }
            this.apolloClient
                .watchQuery({
                query: auth_generated_1.LoggedUserDocument,
                fetchPolicy: 'network-only',
            })
                .subscribe(({ data }) => {
                this.setLoggedUser(data.loggedUser);
                this.loading = false;
            });
        }
        else {
            this.loading = false;
        }
    },
});
let instance;
/** Returns the current instance of the component wrapping the SDK */
const getInstance = () => instance;
exports.getInstance = getInstance;
// Create a simple Vue plugin to expose the wrapper component throughout the application
exports.default = {
    install(Vue, options) {
        instance = new exports.VueAuth0({
            propsData: options,
        });
        Vue.prototype.$auth = instance;
    },
};
